<div class="footer-container">
  <a href="https://www.zceppa.com/?utm_source=zceppa&utm_medium=consumer_link&utm_campaign=review_invite" target="_blank">
    <img class="d-flex footer-image" src="assets/images/powered_by_zceppa.png">
  </a>
  </div>
